import styles from './CurrentMatchFlow.module.css';

interface Props {
  results: string[];
  hasOt?: boolean;
}
export const CurrentMatchFlow = ({ results, hasOt = false }: Props) => {
  return (
    <div>
      <div className={styles.header}>
        {results?.map((_, index) => (
          <div className={styles.headerTitle} key={index}>
            {hasOt && index === results.length - 1 ? 'OT' : `P${index + 1}`}
          </div>
        ))}
      </div>
      <div className={styles.body}>
        {results?.map((x, index) => (
          <div className={styles.result} key={index}>
            {x}
          </div>
        ))}
      </div>
    </div>
  );
};
